var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
	{ 'car_bg' : _vm.carBackCheck },
	{ 'bottom_menu' : _vm.menuShowCheck },
	{ 'stop-scrolling' : (!_vm.onload || _vm.routeLoading) }
],attrs:{"id":"app"}},[_c('vue-progress-bar'),_c('Header'),_c('router-view',{key:_vm.$route.path,staticClass:"content-wrap"}),_c('Footer'),_c('Modal'),(!(!_vm.onload || _vm.routeLoading))?_c('Spinner',{attrs:{"type":"absolute","loading":_vm.loading}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }